module.exports = __webpack_public_path__ + "images/category_lp/common/large-arrow-line-1_0785f1a3e609f3519b5e69162d89e146.png";